import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ListsComponent } from '../../lists.shared.component';
import { IMenuFlowPage } from '@shared/state';

@Component({
    selector: 'shared-list-for-wizzard-products',
    templateUrl: './list-for-wizzard-products.shared.component.html',
    styleUrls: ['./list-for-wizzard-products.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForWizzardProductsComponent extends ListsComponent {
    @Input() public menuFlowProducts: APICommon.IMenuFlowProduct[];
    @Input() public menuFlowPage: IMenuFlowPage;

    constructor() {
        super();
    }

    public menuFlowProductsTrackBy(index: number, item: APICommon.IMenuFlowProduct): number {
        return item?.PageProductIdentifier;
    }
}
